import { TextBox } from '@apply/components';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface OtherDescriptionProps {
    readOnly?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const OtherDescription: React.FC<OtherDescriptionProps> = ({ readOnly = false, propertyGuid, isReview = false }) => {
    const [otherDescription, set_otherDescription] = useBudgetFixFlipField<string>(
        propertyGuid,
        (b) => (b.values?.['Exterior Structure']?.['Other Work']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Exterior Structure': { ...b.values?.['Exterior Structure'], 'Other Work': [v, b.values?.['Exterior Structure']?.['Other Work']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Other - Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={otherDescription}
                />
            ) : (
                <TextBox
                    value={otherDescription}
                    onChange={(value) => set_otherDescription(value)}
                    label={label}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
